import { Component, Input, OnInit } from '@angular/core';
import { ReturnViewService } from '../../../return-view.service';
import {
  INCOME_FORM_VOLUNTARY_DISCLOSURE_COLUMNS,
  VOLUNTARY_DISCLOSURE_INCOME_HEAD_KEY,
  VOLUNTARY_DISCLOSURE_NET_INCOME_KEY,
  VoluntaryDisclosureTableColumn,
} from '../../../../constants/income-from-voluntary-disclosure-constant';

@Component({
    selector: 'app-income-from-voluntary-disclosure-en-v2',
    templateUrl: './income-from-voluntary-disclosure-en-v2.component.html',
    styleUrls: ['./income-from-voluntary-disclosure-en-v2.component.css'],
    standalone: false
})
export class IncomeFromVoluntaryDisclosureEnV2Component implements OnInit {
  @Input() returnData: any;
  @Input() printActive: boolean = false;

  incomeFormVoluntaryDisclosureData: any[] = [];
  incomeHeadLabels: Record<string, string> = {
    INCOME_FROM_EMPLOYMENT: 'Income from Employment',
    INCOME_FROM_FINANCIAL_ASSETS: 'Income from Financial Assets',
    INCOME_FROM_RENT: 'Income from Rent',
    INCOME_FROM_AGRICULTURE: 'Income from Agriculture',
    INCOME_FROM_BUSINESS: 'Income from Business',
    INCOME_FROM_CAPITAL_GAIN: 'Income from Capital Gain',
    INCOME_FROM_OTHER_SOURCES: 'Income from Other Sources',
  };

  readonly tableColumns: VoluntaryDisclosureTableColumn[] = INCOME_FORM_VOLUNTARY_DISCLOSURE_COLUMNS
    .slice()
    .sort((a, b) => a.order - b.order);

  readonly incomeHeadKey = VOLUNTARY_DISCLOSURE_INCOME_HEAD_KEY;
  readonly netIncomeKey = VOLUNTARY_DISCLOSURE_NET_INCOME_KEY;

  constructor(private returnViewService: ReturnViewService) { }

  getValue(item: any, key: string): any {
    return item ? item[key] : null;
  }

  getIncomeHeadTitle(incomeHead: any): string {
    const v = incomeHead === null || incomeHead === undefined ? '' : String(incomeHead).trim();
    return this.incomeHeadLabels[v]
      || v.toLowerCase().split('_').map((word) =>
        word ? word.charAt(0).toUpperCase() + word.slice(1) : ''
      ).join(' ');
  }

  getCellValue(item: any, column: VoluntaryDisclosureTableColumn): any {
    if (column.key === this.incomeHeadKey) {
      return this.getIncomeHeadTitle(this.getValue(item, column.key));
    }
    return this.getValue(item, column.key);
  }

  getTotalNetIncome(): number {
    return this.incomeFormVoluntaryDisclosureData.reduce((sum, item) => {
      const val = Number(this.getValue(item, this.netIncomeKey));
      return sum + (isNaN(val) ? 0 : val);
    }, 0);
  }

  ngOnInit(): void {
    const undisclosedData = this.returnData?.incomeData?.undisclosedData;
    this.incomeFormVoluntaryDisclosureData = Array.isArray(undisclosedData)
      ? undisclosedData
      : [];
  }
}
